var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueryLeftUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 145,
    viewBox: "0 0 137 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.09 49.22V32.5H120.1V24.5H112.1V16.59H104.11V16.4H103.92V8.41H84.46V0.420013H52.5699V8.41H32.1699V16.4V16.59H24.1799V24.5H16.1899V32.5H8.18994V49.22H0.199951V80.66H8.18994V96.33H16.1899V112.32H24.1799V120.31H32.1699V128.3H48.1599V136.3H88.1199V128.3H104.11V120.31H112.1V112.32H120.1V96.33H128.09V80.66H136.08V49.22H128.09Z",
    fill: "#FDAE35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1199 128.28H40.1699V120.29H32.1699H31.9999V112.3H24.1799V104.31H16.1899V96.31H8.18994V80.66H0.199951V96.64H8.18994V112.3H16.1899V120.29H24.0099H24.1799V128.28H32.1699V136.3H52.4299V128.3H40.1699L40.1199 128.28Z",
    fill: "#D38B2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.46 136.32H52.5699V144.31H84.46V136.32Z",
    fill: "#D38B2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.09 80.66V96.31H120.1V104.31H112.1V112.3H104.11V120.29H96.1199V128.28H96.1699L96.1199 128.3H84.3199V136.3H104.11V128.28H112.1V120.29H120.1V112.3H128.09V96.64H136.08V80.66H128.09Z",
    fill: "#D38B2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.11 24.23H96.1199V32.22H104.11V24.23Z",
    fill: "#FFEBD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1199 20.4H92.1199V24.4H96.1199V20.4Z",
    fill: "#FFDAA9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.11 32.22H104.11V36.22H108.11V32.22Z",
    fill: "#FFDAA9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 78.87H80.1299V86.86H112.1V78.87Z",
    fill: "#A32732"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.15 78.87H24.1799V86.86H56.15V78.87Z",
    fill: "#A32732"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1799 57.66H56.15V78.87H64.14V57.66H72.14V78.02H80.1299V57.66H88.1199H96.1199H112.1V78.02H120.1V49.67H16.1899V78.02H24.1799V57.66Z",
    fill: "#A32732"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.15 57.66H24.1799V78.87H56.15V57.66Z",
    fill: "#ECF0F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 57.66H80.1299V78.87H112.1V57.66Z",
    fill: "#ECF0F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.75 55.16H82.5V66.09H88.75V55.16Z",
    fill: "#A32732"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0399 55.16H27.7899V66.09H34.0399V55.16Z",
    fill: "#A32732"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryLeftUp);
export default __webpack_public_path__ + "static/media/query_left-up.32f40d771763f75333957bbfa81d3fec.svg";
export { ForwardRef as ReactComponent };